"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Requestors for analytics-related data
 */
var analytics = require('consumerweb-analytics'), APP_ROOT = require('../app/constants').APP_ROOT, BASE_URI = require('../app/constants').BASE_URI;
/**
 * Generates Analytics pageName from URL
 * @param url
 * @returns string of pageName from URL
 */
function getPageName(url) {
    var nameFromUrl = url.replace(/.*\/myaccount\/(.*?)(\?.*)/, '$1');
    // Removes '/flow' from the url to keep page names consistent
    nameFromUrl = nameFromUrl.replace('/flow', '');
    // Creates consistent page name for /myaccount/profile or /myaccount/profile/
    if (nameFromUrl === APP_ROOT + '/') {
        nameFromUrl = nameFromUrl.replace('/', '');
    }
    if (!nameFromUrl) {
        nameFromUrl = APP_ROOT;
    }
    else {
        // Replace BA-alphanumeric or CC-alphanumeric (i.e remove cards & bank id's)
        // Ex: /money/cards/CC-UCY68ZQHC74NU => /money/cards
        nameFromUrl = nameFromUrl.replace(/\/([BA|CC]+)([-]{1})([a-zA-Z0-9]+)/, '');
        // Ex: /connect/I-123ASDFGHJKL => /connect/id
        var reg = new RegExp(BASE_URI + '\/([I|B|S]\-.*)');
        nameFromUrl = nameFromUrl.replace(reg, BASE_URI + '/id');
        // Adds double colon if there are any trailing name left
        // Ex: cards/update => cards::update
        var regex = new RegExp(APP_ROOT + '\/(.*?)\/', 'g');
        nameFromUrl = nameFromUrl.replace(regex, APP_ROOT + ':$1::');
    }
    return nameFromUrl.replace(/\//g, ':');
}
function initialize(req, res, callback) {
    req.model = req.model || {};
    req.model.analyticsPageName = getPageName(req.originalUrl);
    analytics.setupAnalytics(req, res, callback);
}
/**
 *  Exports Analytics Utils
 */
exports.default = {
    init: initialize,
    getPageNameFromUrl: getPageName
};
